"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceName = void 0;
exports.SpaceName = {
    ARSIA_MONS: '29',
    ASCRAEUS_MONS: '14',
    GANYMEDE_COLONY: '01',
    PHOBOS_SPACE_HAVEN: '02',
    NOCTIS_CITY: '31',
    PAVONIS_MONS: '21',
    THARSIS_THOLUS: '09',
    LUNA_METROPOLIS: '70',
    DAWN_CITY: '71',
    STRATOPOLIS: '72',
    MAXWELL_BASE: '73',
    HELLAS_OCEAN_TILE: '61',
    STANFORD_TORUS: '69',
    VASTITAS_BOREALIS_NORTH_POLE: '33',
    TIKHONAROV: '20',
    LADON: '55',
    FLAUGERGUES: '58',
    CHARYBDIS: '63',
    CERES_SPACEPORT: '75',
    DYSON_SCREENS: '76',
    LUNAR_EMBASSY: '77',
    VENERA_BASE: '78',
    MEDUSAE_FOSSAE: '33',
};
